<template>
  <div class="labelPopulation mb-30">
    <template v-if="conditionType != 3">
      <div class="lab1">
        <p v-if="type == 3">
          <img
            src="../../../assets/images/newIcon/vip_viplabel_icon.png"
            alt=""
          />
          筛选特征组成人群
        </p>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="用户属性" name="1"></el-tab-pane>
          <el-tab-pane label="用户行为" name="2"></el-tab-pane>
          <el-tab-pane label="业务行为" name="3"></el-tab-pane>
        </el-tabs>
        <ul class="list">
          <div v-if="activeName == 2">
            <li v-for="(item, index) in list" :key="index">
              <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
            </li>
          </div>
          <div v-if="activeName == 1">
            <li v-for="(item, index) in list1" :key="index">
              <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
            </li>
          </div>
        </ul>
      </div>
      <div class="lab2">
        <p class="tit" v-if="type == 3">特征</p>
        <p class="tit" v-if="type == 2">人群需同时满足以下特征</p>
        <p class="tit" v-if="type == 4 && conditionType == 1">
          完成以下事件A后
        </p>
        <p class="tit" v-if="type == 4 && conditionType == 2">
          未完成以下事件A后
        </p>
        <ul v-if="activeName == 1">
          <li v-for="(item, index) in list1" :key="index" v-if="item.show">
            <p class="title">{{ item.name }}</p>
            <p class="ft">{{ item.tips }}</p>
            <p v-if="item.id == 1">
              <el-radio-group v-model="item.content.type">
                <el-radio :label="3">青铜会员</el-radio>
                <el-radio :label="6">白银会员</el-radio>
                <el-radio :label="9">黄金会员</el-radio>
                <el-radio :label="4">白金会员</el-radio>
                <el-radio :label="1">钻石会员</el-radio>
              </el-radio-group>
            </p>
            <p v-if="item.id == 2">
              <el-radio-group v-model="item.content.type">
                <el-radio :label="3">男</el-radio>
                <el-radio :label="6">女</el-radio>
                <el-radio :label="9">未知</el-radio>
              </el-radio-group>
            </p>
            <p class="l l2" v-if="item.id == 3">
              <el-popover
                placement="bottom"
                width="400"
                v-model="visible"
                trigger="manual"
              >
                <el-cascader-panel
                  ref="myCascader"
                  v-model="citys"
                  @change="addCity"
                  :props="props"
                  :options="options"
                ></el-cascader-panel>
                <span class="foot">
                  <el-button class="quxiao" @click="ckBut(1)">取 消</el-button>
                  <el-button type="primary" @click="ckBut(2)">保 存</el-button>
                </span>
                <el-button
                  slot="reference"
                  :icon="
                    !checkCitys.length
                      ? 'el-icon-circle-plus-outline'
                      : 'el-icon-edit-outline'
                  "
                  type="text"
                  @click="visible = true"
                  >{{ checkCitys.length ? "修改地区" : "选择地区" }}</el-button
                >
              </el-popover>
            </p>
            <p
              v-if="item.id == 3"
              class="l l3"
              v-for="(t, i) in checkCitys"
              :key="i"
            >
              <span class="t">{{ t.name }}</span>
              <span class="tagl">
                <el-tag
                  size="medium"
                  closable
                  v-for="(c, idx) in t.val"
                  :key="idx"
                  >{{ c }}</el-tag
                >
              </span>
            </p>
            <p v-if="item.id == 4">
              <el-date-picker
                v-model="item.content.text"
                type="daterange"
                range-separator="→"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </p>
            <p v-if="item.id == 6 || item.id == 5">
              <el-select v-model="item.content.timeType" placeholder="请选择">
                <el-option
                  v-for="item in timeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-right: 10px"
                v-if="item.content.timeType == 1"
                v-model="item.content.timeDate"
                type="daterange"
                range-separator="→"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <span v-if="item.content.timeType == 2">
                <el-select v-model="item.content.relative" placeholder="请选择">
                  <el-option
                    v-for="item in relativeTime"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span style="padding-right: 10px; font-size: 14px">天</span>
              </span>
            </p>
            <template v-if="item.id == 12">
              <p class="l l2">
                <el-button
                  slot="reference"
                  icon="el-icon-circle-plus-outline"
                  type="text"
                  >选择渠道</el-button
                >
              </p>
              <p class="l l3">
                <span class="t">小程序</span>
                <span class="tagl">
                  <el-tag size="medium" effect="dark" closable v-for="i in 10"
                    >小程序模版消息</el-tag
                  >
                </span>
              </p>
              <p class="l l3">
                <span class="t">自然注册</span>
                <span>
                  选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                </span>
              </p>
              <p class="l l3">
                <span class="t">自定义渠道</span>
                <span class="tagl">
                  <el-tag size="medium" effect="dark" closable v-for="i in 10"
                    >小程序模版消息</el-tag
                  >
                </span>
              </p>
            </template>
            <p class="l" v-if="item.id == 8">
              <el-select v-model="item.content.type" placeholder="请选择">
                <el-option
                  v-for="item in sizeT"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span v-if="item.content.type == 1 || item.content.type == 2">
                <el-input v-model="item.content.text"></el-input>
                <span>次</span>
              </span>

              <span v-if="item.content.type == 3">
                <el-input v-model="item.content.text"></el-input>
                <span>次</span> <span style="padding: 0 10px">—</span>
                <el-input v-model="item.content.text2"></el-input>
                <span>次</span>
              </span>
            </p>
            <p class="l" v-if="item.id == 7 || item.id == 9">
              <el-select v-model="item.content.type" placeholder="请选择">
                <el-option
                  v-for="item in size"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input v-model="item.content.text"></el-input> <span>元</span>
            </p>
            <p v-if="item.id == 10">
              <el-select v-model="item.content.timeType" placeholder="请选择">
                <el-option
                  v-for="item in timeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="margin-right: 10px"
                v-if="item.content.timeType == 1"
                v-model="item.content.timeDate"
                type="daterange"
                range-separator="→"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <span v-if="item.content.timeType == 2">
                <el-select v-model="item.content.relative" placeholder="请选择">
                  <el-option
                    v-for="item in relativeTime"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span style="padding-right: 10px; font-size: 14px">天</span>
              </span>
              <el-select v-model="item.content.relative" placeholder="请选择">
                <el-option
                  v-for="item in consumption"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
            <p class="l" v-if="item.id == 11">
              <el-select v-model="item.content.type" placeholder="请选择">
                <el-option
                  v-for="item in size"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input v-model="item.content.text"></el-input>
              <span>积分</span>
            </p>
            <i class="el-icon-close close"></i>
          </li>
        </ul>
        <ul v-if="activeName == 2">
          <li v-for="(item, index) in list" :key="index" v-if="item.show">
            <p class="title">{{ item.name }}</p>
            <p class="ft">{{ item.tips }}</p>
            <div style="display: flex">
              <p v-if="item.id != 1 && item.id != 5">
                <el-select v-model="item.content.timeType" placeholder="请选择">
                  <el-option
                    v-for="item in timeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                  style="margin-right: 10px"
                  v-if="item.content.timeType == 1"
                  v-model="item.content.timeDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <span v-if="item.content.timeType == 2">
                  <el-input v-model="item.content.text"></el-input>
                  <span>天内</span>，
                </span>
              </p>

              <p
                class="l"
                v-if="
                  item.id != 1 &&
                  item.id != 7 &&
                  item.id != 13 &&
                  item.name != '访问次数' &&
                  item.name != '是否关注公众号'
                "
              >
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>次</span>
              </p>
              <p class="l" v-if="item.id == 1">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>时</span>
              </p>
              <p class="l l2" v-if="item.id == 7">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in shows"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
              <p class="l l2" v-if="item.id == 13">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in qid"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
              <p v-if="item.name == '访问次数'" class="l l2">
                访问 <el-input v-model="item.content.text2"></el-input>
                <span>次</span>
              </p>
              <p v-if="item.name == '是否关注公众号'" class="l l2">
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in shows"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
            </div>

            <i class="el-icon-close close"></i>
          </li>
          <!-- <li>
                        <p class="title">所在城市（未选效果）</p>
                        <p class="ft">客户的地域信息</p>
                        <p class="l l2" >
                            <el-popover
                            placement="bottom"
                            width="400"
                            v-model="visible"
                            trigger="manual">
                            <el-cascader-panel ref="myCascader" v-model="citys" @change="addCity" :props="props" :options="options"></el-cascader-panel>
                            <span class="foot">
                                <el-button class="quxiao" @click="ckBut(1)">取 消</el-button>
                                <el-button type="primary"  @click="ckBut(2)">保 存</el-button>
                            </span>
                            <el-button slot="reference"
                            :icon="!checkCitys.length ?'el-icon-circle-plus-outline' : 'el-icon-edit-outline'" type="text" @click="visible=true">{{checkCitys.length ? '修改地区' : '选择地区'}}</el-button>
                            </el-popover>
                        </p>
                        <p class="l l3" v-for="(t,i) in checkCitys" :key="i">
                            <span class="t">{{t.name}}</span>
                            <span class="tagl">
                                <el-tag size="medium" closable v-for="(c,idx) in t.val" :key="idx">{{c}}</el-tag>
                            </span>
                            
                        </p>
                        <i class="el-icon-close close"></i>
                    </li>
                    <li>
                        <p class="title">来源渠道</p>
                        <p class="ft">从以下任一渠道（如小程序、自然注册）、方式（如长按识别、搜索打开）成为客户</p>
                        <p class="l l2" >
                            <el-button slot="reference"
                            icon="el-icon-circle-plus-outline" type="text" @click="visible=true">选择渠道</el-button>
                        </p>
                        <p class="l l3">
                            <span class="t">小程序</span>
                            <span class="tagl">
                                <el-tag size="medium" effect="dark" closable v-for="i in 10">小程序模版消息</el-tag>
                            </span>
                        </p>
                        <p class="l l3">
                            <span class="t">自然注册</span>
                            <span >
                            选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                            </span>
                        </p>
                        <p class="l l3">
                            <span class="t">自定义渠道</span>
                            <span class="tagl">
                                <el-tag size="medium" effect="dark" closable v-for="i in 10">小程序模版消息</el-tag>
                            </span>
                        </p>
                        <i class="el-icon-close close"></i>
                    </li> -->
        </ul>
        <p
          v-if="type == 4"
          :style="activeName == 3 ? 'margin-top:30px' : ''"
          class="tis"
        >
          则对受众群体进行触达
        </p>
        <p class="nums">
          人数预览 <el-input v-model="input"></el-input> 人
          <el-button type="text">计算人群</el-button>
        </p>
        <span class="footer" v-if="conditionType != 1 && conditionType != 2">
          <el-button class="quxiao" @click="goType(1)">{{
            type == 2 ? "取消" : "上一步"
          }}</el-button>
          <el-button type="primary" @click="goType(2)">{{
            type == 4 ? "下一步" : "保 存"
          }}</el-button>
        </span>
        <span class="footer" v-if="conditionType == 1 || conditionType == 2">
          <el-button class="quxiao" @click="goType2(1)">上一步</el-button>
          <el-button type="primary" @click="goType2(2)">下一步
          </el-button>
        </span>
      </div>
    </template>
    <div style="width: 100%" v-if="conditionType == 3">
      <div class="labelPopulation2">
        <div class="lab1">
          <p style="padding: 0 20px">
            <!-- <img src="../../../assets/images/newIcon/vip_viplabel_icon.png" alt=""> -->
            完成以下事件A后
          </p>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户属性" name="1"></el-tab-pane>
            <el-tab-pane label="用户行为" name="2"></el-tab-pane>
            <el-tab-pane label="业务行为" name="3"></el-tab-pane>
          </el-tabs>
          <ul class="list">
            <div v-if="activeName == 2 || activeName == 3">
              <li v-for="(item, index) in list" :key="index">
                <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
              </li>
            </div>
            <div v-if="activeName == 1">
              <li v-for="(item, index) in list1" :key="index">
                <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
              </li>
            </div>
          </ul>
        </div>
        <div class="lab2">
          <ul v-if="activeName == 1">
            <li v-for="(item, index) in list1" :key="index" v-if="item.show">
              <p class="title">{{ item.name }}</p>
              <p class="ft">{{ item.tips }}</p>
              <p v-if="item.id == 1">
                <el-radio-group v-model="item.content.type">
                  <el-radio :label="3">青铜会员</el-radio>
                  <el-radio :label="6">白银会员</el-radio>
                  <el-radio :label="9">黄金会员</el-radio>
                  <el-radio :label="4">白金会员</el-radio>
                  <el-radio :label="1">钻石会员</el-radio>
                </el-radio-group>
              </p>
              <p v-if="item.id == 2">
                <el-radio-group v-model="item.content.type">
                  <el-radio :label="3">男</el-radio>
                  <el-radio :label="6">女</el-radio>
                  <el-radio :label="9">未知</el-radio>
                </el-radio-group>
              </p>
              <p class="l l2" v-if="item.id == 3">
                <el-popover
                  placement="bottom"
                  width="400"
                  v-model="visible"
                  trigger="manual"
                >
                  <el-cascader-panel
                    ref="myCascader"
                    v-model="citys"
                    @change="addCity"
                    :props="props"
                    :options="options"
                  ></el-cascader-panel>
                  <span class="foot">
                    <el-button class="quxiao" @click="ckBut(1)"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="ckBut(2)"
                      >保 存</el-button
                    >
                  </span>
                  <el-button
                    slot="reference"
                    :icon="
                      !checkCitys.length
                        ? 'el-icon-circle-plus-outline'
                        : 'el-icon-edit-outline'
                    "
                    type="text"
                    @click="visible = true"
                    >{{
                      checkCitys.length ? "修改地区" : "选择地区"
                    }}</el-button
                  >
                </el-popover>
              </p>
              <p
                v-if="item.id == 3"
                class="l l3"
                v-for="(t, i) in checkCitys"
                :key="i"
              >
                <span class="t">{{ t.name }}</span>
                <span class="tagl">
                  <el-tag
                    size="medium"
                    closable
                    v-for="(c, idx) in t.val"
                    :key="idx"
                    >{{ c }}</el-tag
                  >
                </span>
              </p>
              <p v-if="item.id == 4">
                <el-date-picker
                  v-model="item.content.text"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </p>
              <p v-if="item.id == 6 || item.id == 5">
                <el-select v-model="item.content.timeType" placeholder="请选择">
                  <el-option
                    v-for="item in timeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                  style="margin-right: 10px"
                  v-if="item.content.timeType == 1"
                  v-model="item.content.timeDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <span v-if="item.content.timeType == 2">
                  <el-select
                    v-model="item.content.relative"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in relativeTime"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span style="padding-right: 10px; font-size: 14px">天</span>
                </span>
              </p>
              <template v-if="item.id == 12">
                <p class="l l2">
                  <el-button
                    slot="reference"
                    icon="el-icon-circle-plus-outline"
                    type="text"
                    >选择渠道</el-button
                  >
                </p>
                <p class="l l3">
                  <span class="t">小程序</span>
                  <span class="tagl">
                    <el-tag size="medium" effect="dark" closable v-for="i in 10"
                      >小程序模版消息</el-tag
                    >
                  </span>
                </p>
                <p class="l l3">
                  <span class="t">自然注册</span>
                  <span>
                    选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                  </span>
                </p>
                <p class="l l3">
                  <span class="t">自定义渠道</span>
                  <span class="tagl">
                    <el-tag size="medium" effect="dark" closable v-for="i in 10"
                      >小程序模版消息</el-tag
                    >
                  </span>
                </p>
              </template>
              <p class="l" v-if="item.id == 8">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in sizeT"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span v-if="item.content.type == 1 || item.content.type == 2">
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span>
                </span>

                <span v-if="item.content.type == 3">
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span> <span style="padding: 0 10px">—</span>
                  <el-input v-model="item.content.text2"></el-input>
                  <span>次</span>
                </span>
              </p>
              <p class="l" v-if="item.id == 7 || item.id == 9">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>元</span>
              </p>
              <p v-if="item.id == 10">
                <el-select v-model="item.content.timeType" placeholder="请选择">
                  <el-option
                    v-for="item in timeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                  style="margin-right: 10px"
                  v-if="item.content.timeType == 1"
                  v-model="item.content.timeDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <span v-if="item.content.timeType == 2">
                  <el-select
                    v-model="item.content.relative"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in relativeTime"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span style="padding-right: 10px; font-size: 14px">天</span>
                </span>
                <el-select v-model="item.content.relative" placeholder="请选择">
                  <el-option
                    v-for="item in consumption"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
              <p class="l" v-if="item.id == 11">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>积分</span>
              </p>
              <i class="el-icon-close close"></i>
            </li>
          </ul>
          <ul v-if="activeName == 2 || activeName == 3">
            <li v-for="(item, index) in list" :key="index" v-if="item.show">
              <p class="title">{{ item.name }}</p>
              <p class="ft">{{ item.tips }}</p>
              <div style="display: flex">
                <p v-if="item.id != 1 && item.id != 5">
                  <el-select
                    v-model="item.content.timeType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in timeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    style="margin-right: 10px"
                    v-if="item.content.timeType == 1"
                    v-model="item.content.timeDate"
                    type="daterange"
                    range-separator="→"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <span v-if="item.content.timeType == 2">
                    <el-input v-model="item.content.text"></el-input>
                    <span>天内</span>，
                  </span>
                </p>

                <p
                  class="l"
                  v-if="
                    item.id != 1 &&
                    item.id != 7 &&
                    item.id != 13 &&
                    item.name != '访问次数' &&
                    item.name != '是否关注公众号'
                  "
                >
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in size"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span>
                </p>
                <p class="l" v-if="item.id == 1">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in size"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span>时</span>
                </p>
                <p class="l l2" v-if="item.id == 7">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in shows"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
                <p class="l l2" v-if="item.id == 13">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in qid"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
                <p v-if="item.name == '访问次数'" class="l l2">
                  访问 <el-input v-model="item.content.text2"></el-input>
                  <span>次</span>
                </p>
                <p v-if="item.name == '是否关注公众号'" class="l l2">
                  <el-select v-model="value" placeholder="请选择">
                    <el-option
                      v-for="item in shows"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
              </div>

              <i class="el-icon-close close"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="labelPopulation2">
        <div class="lab1">
          <p style="padding: 0 20px">
            <!-- <img src="../../../assets/images/newIcon/vip_viplabel_icon.png" alt=""> -->
            且未完成以下事件B后
          </p>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户属性" name="1"></el-tab-pane>
            <el-tab-pane label="用户行为" name="2"></el-tab-pane>
            <el-tab-pane label="业务行为" name="3"></el-tab-pane>
          </el-tabs>
          <ul class="list">
            <div v-if="activeName == 2 || activeName == 3">
              <li v-for="(item, index) in list" :key="index">
                <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
              </li>
            </div>
            <div v-if="activeName == 1">
              <li v-for="(item, index) in list1" :key="index">
                <el-checkbox v-model="item.show">{{ item.name }}</el-checkbox>
              </li>
            </div>
          </ul>
        </div>
        <div class="lab2">
          <ul v-if="activeName == 1">
            <li v-for="(item, index) in list1" :key="index" v-if="item.show">
              <p class="title">{{ item.name }}</p>
              <p class="ft">{{ item.tips }}</p>
              <p v-if="item.id == 1">
                <el-radio-group v-model="item.content.type">
                  <el-radio :label="3">青铜会员</el-radio>
                  <el-radio :label="6">白银会员</el-radio>
                  <el-radio :label="9">黄金会员</el-radio>
                  <el-radio :label="4">白金会员</el-radio>
                  <el-radio :label="1">钻石会员</el-radio>
                </el-radio-group>
              </p>
              <p v-if="item.id == 2">
                <el-radio-group v-model="item.content.type">
                  <el-radio :label="3">男</el-radio>
                  <el-radio :label="6">女</el-radio>
                  <el-radio :label="9">未知</el-radio>
                </el-radio-group>
              </p>
              <p class="l l2" v-if="item.id == 3">
                <el-popover
                  placement="bottom"
                  width="400"
                  v-model="visible"
                  trigger="manual"
                >
                  <el-cascader-panel
                    ref="myCascader"
                    v-model="citys"
                    @change="addCity"
                    :props="props"
                    :options="options"
                  ></el-cascader-panel>
                  <span class="foot">
                    <el-button class="quxiao" @click="ckBut(1)"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="ckBut(2)"
                      >保 存</el-button
                    >
                  </span>
                  <el-button
                    slot="reference"
                    :icon="
                      !checkCitys.length
                        ? 'el-icon-circle-plus-outline'
                        : 'el-icon-edit-outline'
                    "
                    type="text"
                    @click="visible = true"
                    >{{
                      checkCitys.length ? "修改地区" : "选择地区"
                    }}</el-button
                  >
                </el-popover>
              </p>
              <p
                v-if="item.id == 3"
                class="l l3"
                v-for="(t, i) in checkCitys"
                :key="i"
              >
                <span class="t">{{ t.name }}</span>
                <span class="tagl">
                  <el-tag
                    size="medium"
                    closable
                    v-for="(c, idx) in t.val"
                    :key="idx"
                    >{{ c }}</el-tag
                  >
                </span>
              </p>
              <p v-if="item.id == 4">
                <el-date-picker
                  v-model="item.content.text"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </p>
              <p v-if="item.id == 6 || item.id == 5">
                <el-select v-model="item.content.timeType" placeholder="请选择">
                  <el-option
                    v-for="item in timeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                  style="margin-right: 10px"
                  v-if="item.content.timeType == 1"
                  v-model="item.content.timeDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <span v-if="item.content.timeType == 2">
                  <el-select
                    v-model="item.content.relative"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in relativeTime"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span style="padding-right: 10px; font-size: 14px">天</span>
                </span>
              </p>
              <template v-if="item.id == 12">
                <p class="l l2">
                  <el-button
                    slot="reference"
                    icon="el-icon-circle-plus-outline"
                    type="text"
                    >选择渠道</el-button
                  >
                </p>
                <p class="l l3">
                  <span class="t">小程序</span>
                  <span class="tagl">
                    <el-tag size="medium" effect="dark" closable v-for="i in 10"
                      >小程序模版消息</el-tag
                    >
                  </span>
                </p>
                <p class="l l3">
                  <span class="t">自然注册</span>
                  <span>
                    选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                  </span>
                </p>
                <p class="l l3">
                  <span class="t">自定义渠道</span>
                  <span class="tagl">
                    <el-tag size="medium" effect="dark" closable v-for="i in 10"
                      >小程序模版消息</el-tag
                    >
                  </span>
                </p>
              </template>
              <p class="l" v-if="item.id == 8">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in sizeT"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span v-if="item.content.type == 1 || item.content.type == 2">
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span>
                </span>

                <span v-if="item.content.type == 3">
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span> <span style="padding: 0 10px">—</span>
                  <el-input v-model="item.content.text2"></el-input>
                  <span>次</span>
                </span>
              </p>
              <p class="l" v-if="item.id == 7 || item.id == 9">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>元</span>
              </p>
              <p v-if="item.id == 10">
                <el-select v-model="item.content.timeType" placeholder="请选择">
                  <el-option
                    v-for="item in timeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-date-picker
                  style="margin-right: 10px"
                  v-if="item.content.timeType == 1"
                  v-model="item.content.timeDate"
                  type="daterange"
                  range-separator="→"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <span v-if="item.content.timeType == 2">
                  <el-select
                    v-model="item.content.relative"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in relativeTime"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span style="padding-right: 10px; font-size: 14px">天</span>
                </span>
                <el-select v-model="item.content.relative" placeholder="请选择">
                  <el-option
                    v-for="item in consumption"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </p>
              <p class="l" v-if="item.id == 11">
                <el-select v-model="item.content.type" placeholder="请选择">
                  <el-option
                    v-for="item in size"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input v-model="item.content.text"></el-input>
                <span>积分</span>
              </p>
              <i class="el-icon-close close"></i>
            </li>
          </ul>
          <ul v-if="activeName == 2 || activeName == 3">
            <li v-for="(item, index) in list" :key="index" v-if="item.show">
              <p class="title">{{ item.name }}</p>
              <p class="ft">{{ item.tips }}</p>
              <div style="display: flex">
                <p v-if="item.id != 1 && item.id != 5">
                  <el-select
                    v-model="item.content.timeType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in timeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    style="margin-right: 10px"
                    v-if="item.content.timeType == 1"
                    v-model="item.content.timeDate"
                    type="daterange"
                    range-separator="→"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <span v-if="item.content.timeType == 2">
                    <el-input v-model="item.content.text"></el-input>
                    <span>天内</span>，
                  </span>
                </p>

                <p
                  class="l"
                  v-if="
                    item.id != 1 &&
                    item.id != 7 &&
                    item.id != 13 &&
                    item.name != '访问次数' &&
                    item.name != '是否关注公众号'
                  "
                >
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in size"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span>次</span>
                </p>
                <p class="l" v-if="item.id == 1">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in size"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-input v-model="item.content.text"></el-input>
                  <span>时</span>
                </p>
                <p class="l l2" v-if="item.id == 7">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in shows"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
                <p class="l l2" v-if="item.id == 13">
                  <el-select v-model="item.content.type" placeholder="请选择">
                    <el-option
                      v-for="item in qid"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
                <p v-if="item.name == '访问次数'" class="l l2">
                  访问 <el-input v-model="item.content.text2"></el-input>
                  <span>次</span>
                </p>
                <p v-if="item.name == '是否关注公众号'" class="l l2">
                  <el-select v-model="value" placeholder="请选择">
                    <el-option
                      v-for="item in shows"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </p>
              </div>

              <i class="el-icon-close close"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="bts">
        <p class="tis">则对受众群体进行触达</p>
        <p class="nums">
          人数预览 <el-input v-model="input"></el-input> 人
          <el-button type="text">计算人群</el-button>
        </p>
        <span class="footer">
          <el-button class="quxiao" @click="goType(1)">上一步</el-button>
          <el-button type="primary" @click="goType(2)">{{
            type == 4 ? "下一步" : "创 建"
          }}</el-button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
const QUERY = {
  keyword_search: "",
  page_index: 1,
  page_size: 10,
};
export default {
  props: {
    type: {
      //type等于4时为场景营销
      type: String,
      default: 0,
    },
    conditionType: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      radio: 3,
      query: JSON.parse(JSON.stringify(QUERY)),
      activeName: "1",
      visible: false,
      input: "",
      citys: [],
      value: "",
      props: { multiple: true },
      checkCitys: [],
      timeType: "",
      timeList: [
        { name: "固定时间", value: 1 },
        { name: "相对时间", value: 2 },
      ],
      options: [
        {
          value: 1,
          label: "广东省",
          children: [
            {
              value: 2,
              label: "深圳市",
            },
            {
              value: 7,
              label: "广州市",
            },
          ],
        },
        {
          value: 17,
          label: "湖南省",
          children: [
            {
              value: 18,
              label: "邵阳市",
            },
            {
              value: 21,
              label: "长沙市",
            },
          ],
        },
      ],
      consumption: [
        { name: "有消费", value: 1 },
        { name: "无消费", value: 2 },
      ],
      relativeTime: [
        { name: "最近", value: 1 },
        { name: "未来", value: 2 },
      ],
      size: [
        { name: "小于", value: 1 },
        { name: "大于", value: 2 },
      ],
      sizeT: [
        { name: "小于", value: 1 },
        { name: "大于", value: 2 },
        { name: "区间", value: 3 },
      ],
      shows: [
        { name: "是", value: 1 },
        { name: "否", value: 0 },
      ],
      qid: [
        { name: "全端启动", value: 1 },
        { name: "单端启动", value: 2 },
      ],
      form: {
        type: "1",
      },
      list1: [
        {
          name: "VIP等级",
          show: true,
          id: 1,
          tips: "用户当前的会员等级",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "性别",
          show: true,
          id: 2,
          tips: "客户的性别",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "所在城市",
          show: true,
          id: 3,
          tips: "客户的地域信息",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "出生年份",
          show: true,
          id: 4,
          tips: "客户的出生日期范围",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "注册时间",
          show: true,
          id: 5,
          tips: "客户的注册时间范围",
          content: {
            text: "",
            type: "",
            relative: 1,
          },
        },
        {
          name: "生日",
          show: false,
          id: 6,
          tips: "客户的生日信息",
          content: {
            text: "",
            relative: 1,
            type: "",
          },
        },
        {
          name: "客单价",
          show: false,
          id: 7,
          tips: "客户在平台的消费iodine/购次",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "消费次数",
          show: false,
          id: 8,
          tips: "客户累计在平台内支付成功的订单数量，删除全部退款的订单",
          content: {
            text: "",
            text2: "",
            type: "",
          },
        },
        {
          name: "累计消费金额",
          show: false,
          id: 9,
          tips: "客户累计在平台内支付成功的订单金额，删除退款金额",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "消费行为",
          show: false,
          id: 10,
          tips: "选定时间内，购买/未购买过商品的客户(以支付成功为准，不剔除退款)",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "积分",
          show: false,
          id: 11,
          tips: "客户当前拥有的积分范围",
          content: {
            text: "",
            type: "",
          },
        },
        {
          name: "来源渠道",
          show: false,
          tips: "客户的来源渠道",
          id: 12,
          content: {
            text: "",
            type: "",
          },
        },
      ],
      list: [
        {
          id: 1,
          name: "访问时长",
          show: true,
          tips: "客户的累计访问时长",
          content: {
            text: "0",
            type: "",
          },
        },
        {
          id: 2,
          name: "访问次数",
          show: true,
          tips: "客户的访问次数",
          content: {
            text: "",
            text2: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 3,
          name: "领取优惠券次数",
          show: true,
          tips: "客户的领取优惠券次数（以券为单位，领取单张券为1次）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 4,
          name: "使用优惠券次数",
          show: true,
          tips: "客户的领取优惠券次数（以券为单位，领取单张券为1次）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 5,
          name: "是否关注公众号",
          show: true,
          tips: "客户的关注公众号情况",
          content: {
            text: "",
            type: "",
          },
        },
        {
          id: 6,
          name: "参与活动次数",
          show: false,
          tips: "客户的活动参与次数",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 7,
          name: "是否分享",
          show: false,
          tips: "客户的分享情况",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 8,
          name: "订单次数",
          show: false,
          tips: "客户的下单次数（不包含“待支付”及未支付的“已取消”订单）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 9,
          name: "取消订单次数",
          show: false,
          tips: "客户的取消订单次数（不包含商家自主取消订单）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 10,
          name: "短信点击次数",
          show: false,
          tips: "指客户点击短信内链接的次数（客户为点击则不统计）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 11,
          name: "push点击次数",
          show: false,
          tips: "APP的push推送点击次数",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 12,
          name: "公众号点击次数",
          show: false,
          tips: "公众号模版消息点击次数",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 13,
          name: "全端启动",
          show: false,
          tips: "客户的端口启动情况（只启动过单个前端，或启动所有前端）",
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
        {
          id: 14,
          name: "完成营销活动",
          tips: "客户的活动完成情况",
          show: false,
          content: {
            text: "",
            type: "",
            timeType: 1,
            timeDate: [],
          },
        },
      ],
    };
  },
  methods: {
    getCascaderObj(val, opt) {
      let arr = [];
      val.map(function (value, index, array) {
        let obj = { name: "", val: [] };
        let idx = opt.findIndex((t) => t.value == value.value);
        obj.name = opt[idx].label;
        for (var itm of opt[idx].children) {
          for (let i = 0; i < value.child.length; i++) {
            if (itm.value == value.child[i]) {
              obj.val.push(itm.label);
            }
          }
        }
        arr.push(obj);
      });
      return arr;
    },
    ckBut(type) {
      if (type == 2) {
        let arr = [];
        let val = this.citys;
        for (let i = 0; i < val.length; i++) {
          let index = arr.findIndex((t) => t.value == val[i][0]);
          if (index != -1) {
            arr[index].child.push(val[i][1]);
          } else {
            arr.push({ value: val[i][0], child: [val[i][1]] });
          }
        }
        this.checkCitys = this.getCascaderObj(arr, this.options);
      }
      this.visible = !this.visible;
    },
    handleClick() {},
    addCity(e, form, thsAreaCode) {
      //  let arr=this.$refs['myCascader'].currentLabels
      // console.log(e,11111)
    },
    goType(type) {
      this.$emit("dostep", { type, list: this.list });
      // if (type == 1) {
      //   this.$router.push({ name: "labelManagement" });
      // } else if (type == 2) {
      //   this.$router.push({ name: "labelManagement" });
      //   this.$message({
      //     message: "恭喜你，保存成功",
      //     type: "success",
      //   });
      // }
    },
    goType2(type) {
      this.$emit("dostep", { type, list: this.list });
      // if (type == 1) {
      //   this.$router.push({ name: "labelManagement" });
      // } else if (type == 2) {
      //   this.$router.push({ name: "labelManagement" });
      //   this.$message({
      //     message: "恭喜你，保存成功",
      //     type: "success",
      //   });
      // }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-range-separator {
  font-size: 18px;
  color: #ccc;
}

/deep/ .el-range-editor.el-input__inner {
  width: 261px;
}
.labelPopulation {
  display: flex;
  justify-content: space-between;
  .lab1 {
    box-sizing: border-box;
    padding: 15px;
    padding-top: 30px;
    width: 262px;
    border-radius: 8px;
    background: #fff;
    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }
    /deep/ .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
    /deep/ .el-tabs__item {
      padding: 0 10px;
      &:last-child {
        padding-right: 0;
      }
      &:first-child {
        padding-left: 0;
      }
    }

    p {
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: 500;
      color: #333940;
    }
    .list {
      margin-top: 30px;
      li {
        text-align: center;
        margin-bottom: 30px;
      }
    }
    /deep/ .el-checkbox__input {
      width: 30px;
      text-align: right;
    }
    /deep/ .el-checkbox__label {
      width: 120px;
      text-align: left;
    }
  }
  .lab2 {
    // padding:30px;
    border-radius: 8px;
    box-sizing: border-box;
    width: -webkit-calc(100% - 300px);
    width: -moz-calc(100% - 300px);
    width: calc(100% - 300px);
    background: #fff;

    /deep/ .el-input .el-input__inner {
      background: #fff;
    }
    ul {
      padding: 30px;
      li {
        margin-bottom: 15px;
        position: relative;
        padding: 15px 30px;
        background: rgba(50, 126, 255, 0.06);
        border-radius: 4px;
        border-left: 7px solid #3d6bfb;
        &:last-of-type {
          margin: 0;
        }
        .title {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
        }
        .ft {
          font-size: 12px;
          font-weight: 400;
          color: #777777;
        }
        p {
          margin-bottom: 15px;
        }
        .l {
          // margin-bottom:0 !important;
          font-size: 14px;
          font-weight: 400;
          // color: #666666;
        }
        .l2 {
          margin-bottom: 15px;
        }
        .l3 {
          display: flex;
          .t {
            display: inline-block;
            width: 80px;
            text-align: right;
            padding-right: 15px;
            font-size: 12px;
            font-weight: 400;
            color: #777777;
          }
          .tagl {
            width: -webkit-calc(100% - 100px);
            width: -moz-calc(100% - 100px);
            width: calc(100% - 100px);
            // width: calc(100%-100px);
          }
        }
        .close {
          position: absolute;
          top: 15px;
          right: 25px;
          width: 16px;
          height: 16px;
          font-weight: bold;
          color: #7a9aff;
        }
      }
    }
  }
  .quxiao.el-button {
    color: #999;
  }
}
.bts {
  background: #fff;
  .tis {
    margin-top: 0px;
    padding-top: 30px;
  }
}
.nums {
  padding: 0 30px;
  padding-bottom: 30px;
  font-size: 14px;
  /deep/ .el-input__inner {
    margin: 0 10px;
    background: #f6f6f6 !important;
    border-radius: 30px;
  }
  /deep/ .el-button {
    margin-left: 15px;
  }
}
.footer {
  display: block;
  background: #fff;
  padding: 15px 30px;
  border-top: 1px solid #ededed;
  .el-button {
    border-radius: 30px;
  }
}
.tit {
  font-size: 16px;
  font-weight: 500;
  color: #333940;
  margin-left: 45px;
  margin-top: 30px;
}
/deep/ .el-input {
  width: 100px;
  margin-right: 15px;
}
/deep/ .el-tag {
  border-radius: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
  // background: #fff;
  // color:#777777;
}
/deep/ .el-cascader-panel.is-bordered {
  border: 0px;
}
.labelPopulation2 {
  display: flex;
  // height:300px;
  // overflow: scroll;
  .lab1 {
    border-bottom: 1px solid #eae4e4;
    border-radius: 8px 0px 0px 0px;
    .list {
      height: 400px;
      overflow-y: auto;
    }
  }
  .lab2 {
    border-bottom: 1px solid #eae4e4;
    border-radius: 0 8px 0px 0;
    width: calc(100% - 262px);
    ul {
      margin-top: 16px;
      height: 450px;
      width: 100%;
      overflow-y: auto;
    }
  }
}
.tis {
  // margin-top:-15px;
  padding: 0 30px;
  padding-bottom: 30px;
  font-size: 16px;
}
/deep/ .el-popover {
  padding: 0;
}
.foot {
  display: block;
  padding: 15px;
  text-align: right;
  border-top: 1px solid #ededed;
  .el-button {
    border-radius: 30px;
  }
  .quxiao.el-button {
    color: #999;
  }
}
</style>